import { Navigate, Route, Routes } from 'react-router-dom'

import { visibleNav } from '@/components/layout/nav'
import { PosLayout } from '@/components/layout/PosLayout'
import { RegisterFrame } from '@/components/layout/RegisterFrame'
import { NoAccessPage } from '@/pages/NoAccessPage'
import { useSession } from '@/contexts/SessionContext'
import { CatalogPage } from '@/pages/CatalogPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { DeviceSetupPage } from '@/pages/DeviceSetupPage'
import { InventoryPage } from '@/pages/InventoryPage'
import { LinkDevicePage } from '@/pages/LinkDevicePage'
import { LockScreen } from '@/pages/LockScreen'
import { LoginPage } from '@/pages/LoginPage'
import { MovingBranchPage } from '@/pages/MovingBranchPage'
import { OrdersPage } from '@/pages/OrdersPage'
import { PricingPage } from '@/pages/PricingPage'
import { ReportsPage } from '@/pages/ReportsPage'
import { SellPage } from '@/pages/SellPage'
import { ShiftPage } from '@/pages/ShiftPage'
import { ShiftsHistoryPage } from '@/pages/ShiftsHistoryPage'
import { StaffPage } from '@/pages/StaffPage'
import { TerminalsPage } from '@/pages/TerminalsPage'

export const AppRoutes = () => {
  const { stage, can } = useSession()

  if (stage === 'unlinked') return <LinkDevicePage />
  if (stage === 'signed_out') return <LoginPage />
  if (stage === 'setting_up') return <DeviceSetupPage />
  if (stage === 'locked') return <LockScreen />
  if (stage === 'moving') return <MovingBranchPage />

  const allowed = new Set(visibleNav(stage, can).map((n) => n.to))
  const landing = visibleNav(stage, can)[0]?.to

  return (
    <Routes>
      <Route element={<PosLayout />}>
        {/* The register: Sale, and this shift's orders and drawer. The rail's Orders / Shift are the full pages. */}
        <Route element={<RegisterFrame />}>
          <Route index element={allowed.has('/') ? <SellPage /> : landing ? <Navigate to={landing} replace /> : <NoAccessPage />} />
          {allowed.has('/orders') && <Route path="register/orders" element={<OrdersPage shiftOnly />} />}
          {allowed.has('/shift') && <Route path="register/shift" element={<ShiftPage />} />}
        </Route>
        {allowed.has('/orders') && <Route path="orders" element={<OrdersPage />} />}
        {allowed.has('/shift') && <Route path="shift" element={<Navigate to="/register/shift" replace />} />}
        {allowed.has('/inventory') && <Route path="inventory" element={<InventoryPage />} />}
        {allowed.has('/terminals') && <Route path="terminals" element={<TerminalsPage />} />}
        {allowed.has('/dashboard') && <Route path="dashboard" element={<DashboardPage />} />}
        {allowed.has('/shifts') && <Route path="shifts" element={<ShiftsHistoryPage />} />}
        {allowed.has('/reports') && <Route path="reports" element={<ReportsPage />} />}
        {allowed.has('/pricing') && <Route path="pricing" element={<PricingPage />} />}
        {allowed.has('/staff') && <Route path="staff" element={<StaffPage />} />}
        {allowed.has('/catalog') && <Route path="catalog" element={<CatalogPage />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
